import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

interface ApiResponse<T = any> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_PALATIUM_API_URL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const request = async <T>(config: AxiosRequestConfig): Promise<ApiResponse<T>> => {
  const response: AxiosResponse<T> = await axiosInstance(config);
  return {
    data: response.data,
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  };
};

const apiClient = {
  get: <T>(url: string, params?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> =>
    request<T>({ ...config, method: 'GET', url, params }),

  post: <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> =>
    request<T>({ ...config, method: 'POST', url, data }),

  put: <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> =>
    request<T>({ ...config, method: 'PUT', url, data }),

  patch: <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> =>
    request<T>({ ...config, method: 'PATCH', url, data }),

  delete: <T>(url: string, params?: any, config?: AxiosRequestConfig): Promise<ApiResponse<T>> =>
    request<T>({ ...config, method: 'DELETE', url, params }),
};

export default apiClient;
